import "./style.css";
import * as THREE from "three";
import Planet from "./planet";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import GUI from "lil-gui";

const scene = new THREE.Scene();

const gui = new GUI();
const params = {
  speed: 10,
};
gui.add(params, "speed").min(0.1).max(25).step(0.1).name("Dauer Erdjahr (Sek)");

// Textures
const loadingManager = new THREE.LoadingManager();
const textureLoader = new THREE.TextureLoader(loadingManager);
const mercuryColor = textureLoader.load("2k_mercury.jpg");
const venusColor = textureLoader.load("2k_venus_atmosphere.jpg");
const earthColor = textureLoader.load("2k_earth_daymap.jpg");
const marsColor = textureLoader.load("2k_mars.jpg");
const jupiterColor = textureLoader.load("2k_jupiter.jpg");
const saturnColor = textureLoader.load("2k_saturn.jpg");
const uranusColor = textureLoader.load("2k_uranus.jpg");
const neptuneColor = textureLoader.load("2k_neptune.jpg");
const sunColor = textureLoader.load("sun_1024.jpg");
sunColor.generateMipmaps = false;
sunColor.minFilter = THREE.NearestFilter;

// Objects

const sunGeometry = new THREE.SphereGeometry(5);
const sunMaterial = new THREE.MeshBasicMaterial({
  map: sunColor,
});
const sun = new THREE.Mesh(sunGeometry, sunMaterial);
scene.add(sun);

// Light
const lightTop = new THREE.PointLight(0xffffff, 1);
lightTop.position.y = 5;
// lightTop.castShadow = true;
const lightBottom = new THREE.PointLight(0xffffff, 1);
lightBottom.position.y = -5;
// lightBottom.castShadow = true;
const lightLeft = new THREE.PointLight(0xffffff, 1);
lightLeft.position.x = -5;
// lightLeft.castShadow = true;
const lightRight = new THREE.PointLight(0xffffff, 1);
lightRight.position.x = 5;
// lightRight.castShadow = true;
sun.add(lightTop);
sun.add(lightBottom);
sun.add(lightLeft);
sun.add(lightRight);

const ambient = new THREE.AmbientLight(0xffffff, 0.1);
scene.add(ambient);

// Sizes
const sizes = { width: window.innerWidth, height: window.innerHeight };

// Camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height);
camera.position.y = 20;
camera.position.z = 30;
camera.lookAt(0, 0, 0);
scene.add(camera);

// Controls
const canvas = document.querySelector(".webgl");
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
// controls.enablePan = false;
controls.minDistance = 6;
// controls.target = earth.planet.position;

// Renderer
const renderer = new THREE.WebGLRenderer({
  canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.shadowMap.enabled = true;

/**
 * Listeners
 */
window.addEventListener("resize", () => {
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update Camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

window.addEventListener("dblclick", () => {
  const fullscreenElement =
    document.fullscreenElement || document.webkitFullscreenElement;

  if (!fullscreenElement) {
    if (canvas.requestFullscreen) {
      canvas.requestFullscreen();
    } else if (canvas.webkitRequestFullscreen) {
      canvas.webkitRequestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  }
});

const raycaster = new THREE.Raycaster();
let mouse = new THREE.Vector2();
console.log("Hello World");
window.addEventListener("click", (event) => {
  console.log("Intersection found");
  event.preventDefault();

  mouse.x = (event.clientX / renderer.domElement.clientWidth) * 2 - 1;
  mouse.y = -(event.clientY / renderer.domElement.clientHeight) * 2 + 1;

  raycaster.setFromCamera(mouse, camera);

  var intersects = raycaster.intersectObjects(planets); //Need array of planet meshs !!!!!

  if (intersects.length > 0) {
    // intersects[0].object.callback();
    focusPlanet(intersects[0].object);
  }
});

let paused = true;
window.addEventListener("keypress", (e) => {
  if (e.key === " ") {
    paused = !paused;
  }
});

let time = Date.now();

let focussedPosition = new THREE.Vector3();
let focussedPlanet;

const focusPlanet = (mesh) => {
  focussedPlanet = mesh;
};

const mercury = new Planet(scene, 12, 0.6, 0xaaaaaa, 87.97, 1, {
  rotation: new THREE.Vector3(0.1, 0, 0.05),
  colorMap: mercuryColor,
});
const venus = new Planet(scene, 20, 0.9, 0x888888, 224.7, 1, {
  colorMap: venusColor,
});
const earth = new Planet(scene, 28, 1, 0xcccccc, 365, 1, {
  colorMap: earthColor,
  rotation: new THREE.Vector3(0, 0, -0.1),
});
earth.addMoon(0.2, 2);

const mars = new Planet(scene, 34, 1.2, 0x444444, 686.98, 1, {
  colorMap: marsColor,
  rotation: new THREE.Vector3(0.05, 0, -0.05),
});

const jupiter = new Planet(scene, 50, 3, 0x444444, 4343.5, 1, {
  colorMap: jupiterColor,
  rotation: new THREE.Vector3(0, 0, 0.05),
});

const saturn = new Planet(scene, 60, 2.5, 0x444444, 10767.5, 1, {
  colorMap: saturnColor,
  rotation: new THREE.Vector3(0.05, 0, 0),
});

const uranus = new Planet(scene, 65, 1.7, 0x444444, 30587, 1, {
  colorMap: uranusColor,
});

const neptun = new Planet(scene, 70, 1.7, 0x444444, 59787, 1, {
  colorMap: neptuneColor,
  rotation: new THREE.Vector3(0.05, 0, -0.05),
});

const planets = [
  sun,
  mercury.planet,
  venus.planet,
  earth.planet,
  mars.planet,
  jupiter.planet,
  saturn.planet,
  uranus.planet,
  neptun.planet,
];

const circles = gui.addFolder("Circles");
circles.add(mercury, "toggleCircle").name("Mercury");
circles.add(venus, "toggleCircle").name("Venus");
circles.add(earth, "toggleCircle").name("Earth");
circles.add(mars, "toggleCircle").name("Mars");
circles.add(jupiter, "toggleCircle").name("Jupiter");
circles.add(saturn, "toggleCircle").name("Saturn");
circles.add(uranus, "toggleCircle").name("Uranus");
circles.add(neptun, "toggleCircle").name("Neptun");

const animate = () => {
  const currentTime = Date.now();
  const deltaTime = (currentTime - time) / 1000;
  time = currentTime;

  // Dauer pro umdrehung der Erde in Sekunden
  let speed = 0;
  if (!paused) speed = (deltaTime * 365) / params.speed;

  mercury.rotate(speed);
  venus.rotate(speed);
  earth.rotate(speed);
  mars.rotate(speed);
  jupiter.rotate(speed);
  saturn.rotate(speed);
  uranus.rotate(speed);
  neptun.rotate(speed);

  sun.rotateY((Math.PI * 2 * speed) / 27.28 / 10);
  focussedPlanet?.getWorldPosition(focussedPosition);
  controls.target = focussedPosition;
  controls.update();

  renderer.render(scene, camera);
  requestAnimationFrame(animate);
};

requestAnimationFrame(animate);
